/*
 * 
 * @Author: Max.Liu 
 * @Date: 2019-06-14 14:21:04 
 * @Last Modified time: 2019-06-14 14:21:04 
 */
'use strict'; 
import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    packageList: []
  },
  mutations: {
    CLASSAJAXHANDLER (state, data) {
      state.packageList = data;
    }
  },
  actions: {
    async classAjaxHandler ({ commit }) {
      let url = `/progress`;
      try{
        let request = await axios.get(url);
        // console.log(request.data)
        // 提交CLASSAJAXHANDLER
        commit("CLASSAJAXHANDLER", request.data);
      }catch(e){
        console.error(e);
      }
    }
  }
});
